@switch (item().fileType) {
  @case (FileType.Image) {
    <div class="attachment-card">
      <div
        (click)="onExpand()"
        class="attachment-preview image-preview">
        @if (hasPreview()) {
          <img
            [src]="item().thumbnailURL || item().imageURL"
            [alt]="item().fileName"
            (error)="onImageError()"
            loading="lazy"
            class="thumbnail-image" />
        } @else {
          <div class="placeholder-icon placeholder-icon--error">
            <i class="pi pi-image"></i>
          </div>
        }
      </div>
      <div class="attachment-content">
        <div class="attachment-info">
          <div class="file-name">{{ item().fileName }}</div>
          @if (item().uploadedBy) {
            <div class="uploaded-by">{{ item().uploadedBy }}</div>
          }
          <div class="uploaded-date">
            {{ 'attachmentUpload.uploaded' | translate }} {{ item().createDate | date: 'M/d/yyyy' }}
          </div>
        </div>
        <div class="attachment-actions">
          <button
            [title]="'attachmentUpload.download' | translate"
            (click)="onDownload()"
            type="button"
            class="action-button download-button">
            <i class="pi pi-download"></i>
          </button>
          <button
            [title]="'common.delete' | translate"
            (click)="onDelete()"
            type="button"
            class="action-button delete-button">
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </div>
    </div>
  }
  @case (FileType.Document) {
    <div class="document-card">
      <div class="document-icon">
        <i class="pi pi-file"></i>
      </div>
      <div class="document-info">
        <div class="file-name">{{ item().fileName }}</div>
        @if (item().uploadedBy) {
          <div class="uploaded-by">{{ item().uploadedBy }}</div>
        }
        <div class="uploaded-date">
          {{ 'attachmentUpload.uploaded' | translate }} {{ item().createDate | date: 'M/d/yyyy' }}
        </div>
      </div>

      <div
        [class.hidden]="!canDelete() && !canDownload()"
        class="document-actions">
        <button
          [class.hidden]="!canDownload()"
          [title]="'attachmentUpload.download' | translate"
          (click)="onDownload()"
          type="button"
          class="action-button download-button">
          <i class="pi pi-download"></i>
        </button>

        <button
          [class.hidden]="!canDelete()"
          [title]="'common.delete' | translate"
          (click)="onDelete()"
          type="button"
          class="action-button delete-button">
          <i class="pi pi-trash"></i>
        </button>
      </div>
    </div>
  }
  @default {
    <div class="link-card">
      <div class="link-icon">
        <i class="pi pi-link"></i>
      </div>
      <div class="link-info">
        <a
          [href]="item().fileName"
          [title]="item().fileName"
          target="_blank"
          rel="noopener noreferrer"
          class="link-url">
          {{ item().fileName }}
        </a>
        @if (item().uploadedBy) {
          <div
            [title]="item().uploadedBy"
            class="uploaded-by">
            {{ item().uploadedBy }}
          </div>
        }
        <div class="uploaded-date">
          {{ 'attachmentUpload.uploaded' | translate }} {{ item().createDate | date: 'M/d/yyyy' }}
        </div>
      </div>
      <div class="link-actions">
        <button
          [title]="'common.delete' | translate"
          (click)="onDelete()"
          type="button"
          class="action-button delete-button">
          <i class="pi pi-trash"></i>
        </button>
      </div>
    </div>
  }
}
